var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoCalendarIn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cf3knge2oa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.133333 0 0 0 0 0.152941 0 0 0 0 0.164706 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cf3knge2oa)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#A5ADBD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.885 3.422a2.153 2.153 0 0 0-2.153-2.153H2.153A2.153 2.153 0 0 0 0 3.422v9.307c0 1.19.964 2.153 2.153 2.153h10.58c1.189 0 2.152-.964 2.152-2.153V3.422z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M4.329 0v2.538M10.557 0v2.538"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADBD",
    d: "M3.5 7.375h1.75v-1.75H3.5zM3.5 11h1.75V9.25H3.5zM6.625 7.375h1.75v-1.75h-1.75zM6.625 11h1.75V9.25h-1.75zM9.75 7.375h1.75v-1.75H9.75z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5ADBD",
    cx: 10.962,
    cy: 6.346,
    r: 1.731
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADBD",
    d: "M9.75 11h1.75V9.25H9.75z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoCalendarIn);
export default __webpack_public_path__ + "static/media/PictoCalendarIn.ffe2a02db04a48261a9797d6bbc1eb5b.svg";
export { ForwardRef as ReactComponent };